import { FilterMenuOptions } from 'app/components/filters/types';
import { ApplicationState } from 'app/types-store';

export const selectFilterInstance = (instanceKey: string) => (state: ApplicationState) =>
  state.filters?.instances?.[instanceKey];

export const selectCurrentList = (instanceKey: string) => (state: ApplicationState) =>
  state.filters?.instances?.[instanceKey]?.currentList;

export const selectAdvancedSearchFields = (instanceKey: string) => (state: ApplicationState) =>
  state.filters?.instances?.[instanceKey]?.advancedSearchFields;

export const selectAdvancedSearchTypes = (instanceKey: string) => (state: ApplicationState) =>
  state.filters?.instances?.[instanceKey]?.advancedSearchTypes;

export const selectFilterDomains = (instanceKey: string) => (state: ApplicationState) =>
  state.filters?.instances?.[instanceKey]?.filterDomains;

export const selectReportData = (instanceKey: string) => (state: ApplicationState) =>
  state.filters?.instances?.[instanceKey]?.reportData;

export const selectIsCaseTypeOptionExcluded = (instanceKey: string, caseTypeDomainId: number) => (state: ApplicationState) =>
  state.filters?.instances?.[instanceKey]?.currentList?.
    find(item => item.domain === caseTypeDomainId)
    ?.menuOptions?.some(item => item.option === FilterMenuOptions.Exclude) ?? false;
